import React, { useEffect, Fragment, useState } from 'react';
import { Loading } from '../Common';
import CheckboxTree from '../Common/Collapse/CheckboxTree';
import './DDMCasOrganization.scss';

export const DDMCasOrganization = (props) => {
  const { selectedCasDetails, casOrganizations, onSelectOrganization, loading } = props;
  const [showDDMenu, setShowDDMenu] = useState(false);
  const [focusToChild, setFocusToChild] = useState(false);

  const ddmHeaderRef = React.createRef();
  const ddmInnerContainerRef = React.createRef();
  const ddmClientHeaderRef = React.createRef();

  const disableDDM = casOrganizations && casOrganizations.length === 1 && casOrganizations[0].clients.length === 1;

  const focusToSelectedChild = (status = true) => {
    setTimeout(() => {
      setFocusToChild(status);
    }, 10);
  };

  const closeIfNoFocus = () => {
    setTimeout(() => {
      if (ddmInnerContainerRef.current && !ddmInnerContainerRef.current.contains(document.activeElement)) {
        setShowDDMenu(false);
      }
    }, 10);
  };

  const isEllipsisActive = () => {
    const offsetWidth = ddmClientHeaderRef.current.offsetWidth;
    const scrollWidth = ddmClientHeaderRef.current.scrollWidth;
    if (offsetWidth < scrollWidth) {
      ddmClientHeaderRef.current.setAttribute('title', selectedCasDetails.clientName);
    } else {
      ddmClientHeaderRef.current.removeAttribute('title');
    }
  };

  const handleOnLastSelected = () => {
    setTimeout(() => {
      if (ddmInnerContainerRef.current) {
        const ddmContainerRef = ddmInnerContainerRef.current;
        ddmContainerRef.scrollTop = ddmContainerRef.scrollHeight;
      }
    }, 10);
  };

  const handleOnKeyDown = (disabled, e) => {
    const { key } = e;
    if ((key === 'Tab' && !showDDMenu) || disabled) {
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    switch (key) {
      case ' ':
        setShowDDMenu(true);
        break;
      case 'Enter':
        setShowDDMenu(true);
        break;
      case 'Escape':
        setShowDDMenu(false);
        break;
      case 'ArrowDown':
        setShowDDMenu(true);
        break;
      case 'ArrowUp':
        setShowDDMenu(false);
        break;
      default:
    }
  };

  const renderDropdown = () => {
    return casOrganizations?.length > 0 ? (
      <Fragment>
        <div
          tabIndex={focusToChild ? '-1' : '0'}
          id={'ddmCasOrgs'}
          data-testid={'ddmCasOrgs'}
          role="menu"
          aria-controls="ddm_menu_id"
          aria-haspopup="true"
          aria-expanded={showDDMenu}
          aria-label={`cas/organization selector ${showDDMenu ? 'opened' : 'closed'}`}
          ref={ddmHeaderRef}
          onClick={() => setShowDDMenu(!showDDMenu)}
          onFocus={focusToSelectedChild.bind(this, false)}
          onBlur={closeIfNoFocus.bind(this)}
          onKeyDown={handleOnKeyDown.bind(this, disableDDM)}
          onMouseEnter={isEllipsisActive.bind(this)}
          className={'ddm-header'}>
          <div>{selectedCasDetails.name}</div>
          <div className="text-bellow" ref={ddmClientHeaderRef} role={'menuitem'}>
            {selectedCasDetails.clientName}
          </div>
          <div className={'ddm-icon'}>
            <i className="fa fa-caret-down mLeft-5" />
          </div>
        </div>
        {showDDMenu ? (
          <CheckboxTree
            refWrapper={ddmInnerContainerRef}
            classNames={`ddm-content`}
            id="ddm_menu_id"
            ariaLabelledby={'ddmCasOrgs'}
            disableTab={true}
            selectedIds={[selectedCasDetails.clientId]}
            onSelectLastElement={handleOnLastSelected.bind(this)}
            hasFocus={focusToChild}
            setFocusToSelected={setFocusToChild}
            closeDDM={() => {
              setShowDDMenu(false);
              ddmHeaderRef.current.focus();
            }}
            closeOnBlurDDM={() => {
              closeIfNoFocus();
            }}
            headerRef={ddmHeaderRef}
            nodes={casOrganizations}
            singleSelect={true}
            isActiveDDMenu={showDDMenu}
            onSelectCheckbox={(casDetails) => {
              onSelectOrganization(casDetails);
              setShowDDMenu(false);
              ddmHeaderRef.current.focus();
            }}
          />
        ) : null}
      </Fragment>
    ) : null;
  };

  return (
    <Fragment>
      <div id={'navDDM'} className={`ddm-tree-container ${disableDDM ? 'ddm-disabled' : ''}`}>
        {renderDropdown()}
        <Loading show={loading} classNames={['app-ddm-loading']} />
      </div>
    </Fragment>
  );
};

export default DDMCasOrganization;
